import { getResult } from 'helpers/request';
import { EContentType } from '../../constants/content';
import { bffServiceClient } from '../../packages/request/clients';
import { IContentParam } from '../../interfaces';

const findContentByType = async (
  content: EContentType,
  params: IContentParam
) => {
  return bffServiceClient
    .get(`/merchantService/content/${content}`, {
      params,
    })
    .then(getResult);
};

export default { findContentByType };
